module.exports = __webpack_public_path__ + "media/images/911-6c5ef408c36c9c15dec44141b8e8ff64.svg";